const rewardsActionTypes = {
    ADD_REWARD: 'ADD_REWARD',
    DELETE_REWARD: 'DELETE_REWARD',
    EDIT_REWARD_TEXT: 'EDIT_REWARD_TEXT',
    SET_COMPLETED: 'SET_COMPLETED',
    SET_REWARDS: 'SET_REWARDS',
    SET_SELECTED_REWARD_ID: 'SET_SELECTED_REWARD_ID'
};

export default rewardsActionTypes;